module.exports = {"410505001":"梅园庄街道","410505002":"李珍街道","410505003":"电厂路街道","410505004":"纱厂路街道","410505005":"铁西路街道","410505006":"水冶街道","410505007":"清风街街道","410505008":"北蒙街道","410505009":"相台街道","410505200":"西郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410505.json
// module id = 1438
// module chunks = 0